<template>
  <lb-dialog 
    v-model="dialog" 
    :heading="`Bulk Upload ${$nova.labelsName('user_management', 'user_label', 'Users')}`" 
    :width="(fileData.length > 0) ? '80%' : '60%'" 
    :loading="loading"
  >
    <template v-slot:body>
      <div>
        <div v-if="fileData.length === 0">
          <div class="mb-2 d-flex flex-column align-center justify-center gap-3">
            <div class="d-flex justify-start" style="width: 100%">
              <base-button primary target="_blank" @click="downloadTemplate()" label="Download template" />
            </div>
            <DragDropFileWithIcon
              :files="file ? [file] : []"
              :loading="processing"
              :multiplefiles="false"
              accept=".xlsx,.xls,.xlsm,.xlsb,.csv"
              @update:files="handleFileUpdate"
            />
          </div>
          <div class="grey--text pa-6 text-center title">
            Download the template, update the details and upload the file.
          </div>
        </div>
        <div v-else class="d-flex flex-column gap-3">
          <div class="d-flex justify-space-between gap-2">
            <base-button primary target="_blank" @click="downloadTemplate()" label="Download template" />
            <base-button secondary outlined @click="reUploadFile" label="Re-upload" prepend-icon="mdi-upload" />
          </div>
          
          <lb-datatablenew
            :headers="headers"
            :items="items"
            :loading="false"
            :hideColumnSelector="true"
          >
             <template v-slot:item.error="{ item }">
                <span class="error--text">{{ item.error }}</span>
             </template>
          </lb-datatablenew>
        </div>
      </div>
    </template>
    <template v-slot:actions>
      <div v-if="hasErrors" class="px-2 error--text font-weight-bold">
        Please provide all valid details
      </div>
      <v-spacer></v-spacer>
      <base-button 
        v-if="items.length > 0 && !hasErrors"
        @click="uploadUsers" 
        primary 
        class="ml-2 shadow-off"
        :disabled="loading"
        label="Proceed to Upload"
      />
    </template>
  </lb-dialog>
</template>

<script>
import DragDropFileWithIcon from '@/views/Inputs/DragDropFileWithIcon.vue';

export default {
  name: 'UserPermissionBulkUploadDialog',
  components: {
    DragDropFileWithIcon
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    headers: {
        type: Array,
        default: () => []
    },
    loading: {
        type: Boolean,
        default: false
    },
    file: {
        type: [File, Array],
        default: null
    }
  },
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    hasErrors() {
      return this.items.some(item => item.error);
    },
    fileData() { return this.items } // Alias for compat if needed, but template uses items now
  },
  methods: {
    downloadTemplate() {
      this.$emit('download-template');
    },
    handleFileUpdate(files) {
      if (files && files.length > 0) {
        this.$emit('process-file', files);
      }
    },
    reUploadFile() {
      this.$emit('reset-data');
    },
    uploadUsers() {
      this.$emit('upload-data');
    }
  }
};
</script>

<style scoped>
.secondaryBtn {
    background-color: white !important;
    border: 1px solid var(--color-primary);
    color: var(--color-primary) !important;
}
</style>